module.exports = __webpack_public_path__ + "static/media/happy.f74c2423.svg";